import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/css/v4-shims.css";
import "@widgetjs/tree";
import "chart.js";
import "datatables.net";
import "datatables.net-scroller";
import "handlebars";
import "i18next";
import "i18next-browser-languagedetector";
import "i18next-xhr-backend";
import "imask";
import "jquery";
import "jquery-ui/themes/base/base.css";
import "jquery-ui/themes/base/core.css";
import "jquery-ui/themes/base/dialog.css";
import "jquery-ui/themes/base/theme.css";
import "jquery-ui/ui/widgets/dialog";
import "marked";
import "navigo";
import "notyf";
import "parse-decimal-number";
import "validate.js";

import Mousetrap from "mousetrap";

Mousetrap.prototype.stopCallback = function(e, element, combo) {
    // Only stopt if the input is configured to avoid it
    if ((' ' + element.className + ' ').indexOf(' no-mousetrap ') > -1) {
        return true;
    }

    return false;
}